import { render, staticRenderFns } from "./files.vue?vue&type=template&id=1fb44c38&scoped=true&lang=html&"
import script from "./files.vue?vue&type=script&lang=js&"
export * from "./files.vue?vue&type=script&lang=js&"
import style0 from "./files.vue?vue&type=style&index=0&id=1fb44c38&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb44c38",
  null
  
)

component.options.__file = "files.vue"
export default component.exports